import { NavLink, useParams } from 'react-router-dom';

import { buildShareUrl, parseMarkdown, sanitizeImageUrl, imageWidth, ServiceEnum } from 'utils';
import { ArticleContent } from 'components/article-content';
import { Container } from 'components/container';
//import { VictimsList } from 'components/victims-list';
import { Layout } from 'components/layout';
import { IconFacebook } from 'components/icons/facebook';
import { IconTelegram } from 'components/icons/telegram';
import { IconVk } from 'components/icons/vk';
import { useDataContext } from 'context/data-context';
import { useLocale } from 'locale';
import { FemaleIcon } from './female-icon';
import { MaleIcon } from './male-icon';
import { featuredData } from './featured-data-uz';
import { additionalTexts } from './additional-texts';
import {
  Dl,
  Dt,
  Dd,
  Profile,
  PhotoContainer,
  Title,
  Social,
  SubmitInfo,
  ImageWrapper,
  ProfileWrapper,
  ArticleFeatured,
  Label,
  Source,
} from './styled';
import { IconWhatsapp } from 'components/icons/whatsapp';

const shareOptions = [
  { component: IconFacebook, service: 'facebook' },
  { component: IconWhatsapp, service: 'whatsapp' },
  //{ component: IconVk, service: 'vk' },
  { component: IconTelegram, service: 'telegram' },
];

const getFormattedDate = (dateString: string | undefined, globalDate: string) => {
  if (!dateString) {
    return globalDate;
  }

  const date = new Date(dateString);

  if (isNaN(date.valueOf())) {
    // Invalid date
    return globalDate;
  }

  return date.toLocaleDateString();
};

export const Detail = () => {
  const params = useParams();
  const { people } = useDataContext();
  const locale = useLocale();
  const person = people.find((p) => p.id.toString() === params.id);

  if (!person) {
    return (
      <Container>
        <p>Not found</p>
      </Container>
    );
  }

  return (
    <Layout>
      <Container>
        <ProfileWrapper>
          <Profile>
            <PhotoContainer>
              {person.Photo_URL ? (
                <ImageWrapper>
                  <img src={imageWidth(person.Photo_URL, 460)} alt="" />
                  {/*<img src={sanitizeImageUrl(person.Photo_URL, 460)} alt="" />*/}
                </ImageWrapper>
              ) : (
                <MaleIcon />
              )}
            </PhotoContainer>
            <Title>
              {person.Name} {person.Surname}
            </Title>
            <Dl>
              <div>
                <Dt>{locale.profile.work}: </Dt>
                <Dd>{person.Work || locale.profile.missingData}</Dd>
                <Dt>{locale.profile.occupation}: </Dt>
                <Dd>{person.Ocupation || locale.profile.missingData}</Dd>
                <Dt>{locale.profile.detainedTime}: </Dt>
                <Dd>{person['Detained time'] || locale.profile.missingData}</Dd>
                <Dt>{locale.profile.accusation}: </Dt>
                <Dd>{person.Accusation || locale.profile.missingData}</Dd>
              </div>
              <div>
                <Dt>{locale.profile.prisonTerm}: </Dt>
                <Dd>{person['Prison Term'] || locale.profile.missingData}</Dd>
                <Dt>{locale.profile.releasedTime}: </Dt>
                <Dd>{person['Released time'] || locale.profile.missingData}</Dd>
                <Dt>{locale.profile.persecution}: </Dt>
                <Dd>{person.Persecution || locale.profile.missingData}</Dd>
                <Dt>{locale.profile.pressure}: </Dt>
                <Dd>{person.Pressure || locale.profile.missingData}</Dd>
              </div>
            </Dl>
            <Social>
              {locale.profile.share}
              <ul>
                {shareOptions.map((s) => (
                  <li key={s.service}>
                    <a
                      href={buildShareUrl(s.service as ServiceEnum)}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <s.component />
                    </a>
                  </li>
                ))}
              </ul>
            </Social>
            <SubmitInfo className="underline">
              <div>
                <NavLink to="/send-data">{locale.profile.sendData}</NavLink>
              </div>
            </SubmitInfo>
          </Profile>
          {/*!!person.Source_of_data && (
            <Source>
              {locale.profile.source}: {person.Source_of_data}
            </Source>
          )*/}
        </ProfileWrapper>

        {/*!!person['Additional text'] && (
          <ArticleContent className="underline" withMargins>
            {parseMarkdown(person['Additional text'])}
          </ArticleContent>
        )*/}

        <ArticleFeatured>
          {additionalTexts[(person.id + 1) as keyof typeof additionalTexts]}
        </ArticleFeatured>
        {/*person.id === 9 && <ArticleFeatured>{featuredData[8]}</ArticleFeatured>}
        {person.id === 39 && <ArticleFeatured>{featuredData[38]}</ArticleFeatured>}
        {person.id === 4 && <ArticleFeatured>{featuredData[3]}</ArticleFeatured>}
        {person.id === 3 && <ArticleFeatured>{featuredData[2]}</ArticleFeatured>}
        {person.id === 1 && <ArticleFeatured>{featuredData[0]}</ArticleFeatured>}
        {person.id === 24 && <ArticleFeatured>{featuredData[23]}</ArticleFeatured>*/}
      </Container>

      {/*<VictimsList person={person} />*/}
    </Layout>
  );
};
